import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const RobesSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$hpCopy' });

  return (
    <section className="base-section robes-section main-hp hp-section">
      <div className="module spa clearfix">
        <Link href={t('robesLink')}>
          <div className="title">
            <div className="inner-title">
              <h2>{t('robesHeading')}</h2>
              <p>{t('robesText')}</p>
              <Button ariaLabel={t('robesCta')}>{t('robesCta')}</Button>
            </div>
          </div>
          <div className="branding-hero">
            <picture>
              <source
                srcSet="/images/homepage/robesSection/kem-bathrobes-mob.webp"
                media="(max-width: 768px)"
              />
              <img
                src="/images/homepage/robesSection/kem-bathrobes-dsktp.webp"
                alt="Robes"
                width={1920}
                height={1080}
              />
            </picture>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default RobesSection;
